import "./Edras.css";
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SeoHelmet from "../components/SeoHelmet";
// import Consultation from "../components/Consultation";

const Edras = () => {

    const [hover, setHover] = useState(false);

    const steps = [
        {
            num: "1",
            title: "Deploy and Configure",
            desc: "Set up cloud hosting, import baseline school data, and activate the modules your institution needs."
        },
        {
            num: "2",
            title: "Create User Accounts",
            desc: "Generate role-specific logins for admins, teachers, parents, students, and support staff."
        },
        {
            num: "3",
            title: "Set Up Classes and Subjects",
            desc: "Map your academic year, class sections, subjects, and assign teacher responsibilities."
        },
        {
            num: "4",
            title: "Start Daily Operations",
            desc: "Enable live attendance, fee tracking, academic reports, and parent notifications from day one."
        }
    ];

    const faqs = [
        {
            id: "f1",
            question: "What is a School Management System?",
            answer:
                "A centralized platform that digitizes student admissions, daily attendance, fee collection, exam management, timetabling, and communication for every school stakeholder in one place."
        },
        {
            id: "f2",
            question: "Who can use this system?",
            answer:
                "Admin, Manager, Teacher, Student, Parent, and Staff users each access a separate portal with role-specific permissions and relevant features only."
        },
        {
            id: "f3",
            question: "Does it work on mobile devices?",
            answer:
                "Yes. The platform is fully responsive and installable as a Progressive Web App (PWA) on smartphones and tablets — no app store download needed."
        },
        {
            id: "f4",
            question: "Can we notify parents instantly?",
            answer:
                "Yes. Web push notifications can be sent for absence alerts, fee reminders, exam schedules, and school announcements with no app installation required."
        },
        {
            id: "f5",
            question: "Is school data secure and access restricted?",
            answer:
                "The system enforces role-based access control so each user only sees data relevant to their role. Secure authentication protects all student and school records."
        }
    ];

    return (
        <>
            <SeoHelmet
                title="Cloud School Management System | School ERP Software | EdRAS"
                description="cloud school management system, school ERP software, student management system, school fee management, attendance software for schools, parent portal, school mobile app, school administration software India"
                url="https://eaximo.com/edras"
                image="https://eaximo.com/meta-image/edras.jpg"
            />

            <Navbar />
            <main>

                <header className="sms-hero">
                    <div className="container position-relative" style={{ zIndex: 1 }}>
                        <div className="row align-items-center g-5">
                            <div className="col-lg-7">
                                <span className="hero-eyebrow">
                                    <i className="bi bi-cloud-fill"></i> Cloud-Based School ERP
                                </span>
                                <h1>Cloud School Management System for Every Campus</h1>
                                <p className="lead">
                                    Unify student records, attendance, fees, academics, and
                                    communications in one secure cloud platform — purpose-built for
                                    Admin, Teacher, Parent, and Student workflows.
                                </p>
                                <div className="d-flex flex-wrap gap-3 mt-4">
                                    <Link
                                        to="https://edras.eaximo.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn-hero-white"
                                    >
                                        <i className="bi bi-box-arrow-up-right me-1"></i> Launch Live App
                                    </Link>
                                    <Link
                                        to="https://wa.me/919474460058?text=Hello%20Anupam%2C%20I%20want%20to%20book%20a%20demo%20for%20the%20Cloud%20School%20Management%20System."
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn-hero-outline"
                                    >
                                        <i className="bi bi-whatsapp me-1"></i> Book a Demo
                                    </Link>
                                </div>
                                <div className="hero-stat-row">
                                    <div className="h-stat">
                                        <span className="val">6</span>
                                        <span className="lbl">Role Portals</span>
                                    </div>
                                    <div className="h-stat">
                                        <span className="val">15+</span>
                                        <span className="lbl">Modules</span>
                                    </div>
                                    <div className="h-stat">
                                        <span className="val">100%</span>
                                        <span className="lbl">PWA Ready</span>
                                    </div>
                                    <div className="h-stat">
                                        <span className="val">24/7</span>
                                        <span className="lbl">Cloud Access</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 d-none d-lg-block">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="ratio ratio-16x9">
                                            <iframe
                                                width="560"
                                                height="315"
                                                src="https://www.youtube-nocookie.com/embed/NaZe19pJhXE?si=vazVQHbK3x_wFTid"
                                                title="YouTube video player"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                referrerPolicy="strict-origin-when-cross-origin"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </div>
                                </div>
                                {/* Optional dashboard widget (commented out) */}
                            </div>
                        </div>
                    </div>
                </header>

                {/* ===== FEATURES ===== */}
                <section id="features" style={{ background: "#fff" }}>
                    <div className="container">
                        <div className="text-center mb-5">
                            <span className="sec-label">Core Features</span>
                            <h2 className="sec-heading">
                                Everything Your School Needs in One Platform
                            </h2>
                            <p className="sec-sub mx-auto">
                                Reduce manual paperwork and fragmented tools. Manage academic,
                                administrative, and financial operations with one connected
                                system.
                            </p>
                        </div>
                        <div className="row g-4">
                            {[
                                {
                                    icon: "bi bi-people",
                                    title: "Student Information System",
                                    desc: "Complete student profiles with guardian data, enrollment history, and searchable academic records."
                                },
                                {
                                    icon: "bi bi-calendar-check",
                                    title: "Attendance Management",
                                    desc: "Daily attendance for students and teachers with trend tracking and automated absence notifications."
                                },
                                {
                                    icon: "bi bi-journal-check",
                                    title: "Grade and Exam Management",
                                    desc: "Record marks by exam type, auto-compute grades from custom scales, and publish results securely."
                                },
                                {
                                    icon: "bi bi-cash-coin",
                                    title: "Fee and Payment Tracking",
                                    desc: "Configure fee structures, track dues, issue receipts, and monitor collection with finance dashboards."
                                },
                                {
                                    icon: "bi bi-clock-history",
                                    title: "Timetable Scheduling",
                                    desc: "Create class timetables, prevent teacher conflicts, and publish updates to all stakeholders instantly."
                                },
                                {
                                    icon: "bi bi-megaphone",
                                    title: "Notices and Announcements",
                                    desc: "Broadcast notices school-wide or target specific roles, classes, or departments instantly."
                                }
                            ].map((feat, idx) => (
                                <div className="col-md-6 col-lg-4" key={idx}>
                                    <div className="feat-card">
                                        <div className="feat-icon">
                                            <i className={feat.icon}></i>
                                        </div>
                                        <div className="feat-body">
                                            <h3>{feat.title}</h3>
                                            <p>{feat.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* ===== ROLE PORTALS ===== */}
                <section id="roles" style={{ background: "#f8f9fa" }}>
                    <div className="container">
                        <div className="mb-5">
                            <span className="sec-label">Role Portals</span>
                            <h2 className="sec-heading">A Dedicated Dashboard for Every User</h2>
                            <p className="sec-sub">
                                Each user signs in to a tailored interface — with only the tools and
                                data relevant to their specific responsibility.
                            </p>
                        </div>

                        {/* Tabs */}
                        <ul
                            className="nav role-pill-wrap flex-wrap mb-4"
                            id="roleTabs"
                            role="tablist"
                        >
                            {["Admin", "Manager", "Teacher", "Student", "Parent", "Staff"].map(
                                (role, idx) => (
                                    <li className="nav-item" role="presentation" key={idx}>
                                        <button
                                            className={`nav-link ${idx === 0 ? "active" : ""}`}
                                            data-bs-toggle="pill"
                                            data-bs-target={`#r-${role.toLowerCase()}`}
                                            type="button"
                                            role="tab"
                                        >
                                            {role}
                                        </button>
                                    </li>
                                )
                            )}
                        </ul>

                        {/* Tab Content */}
                        <div className="tab-content" id="roleTabContent">
                            {/* Admin */}
                            <div
                                className="tab-pane fade show active"
                                id="r-admin"
                                role="tabpanel"
                            >
                                <div className="role-pane">
                                    <div className="role-pane-icon">
                                        <i className="bi bi-shield-lock"></i>
                                    </div>
                                    <h3>Administrator — Full System Control</h3>
                                    <p className="role-desc">
                                        The central authority with full access to manage all users,
                                        modules, and configure school-wide settings from a single
                                        command center.
                                    </p>
                                    <ul className="role-feat-list">
                                        <li><i className="bi bi-check-circle-fill"></i> Manage all users and roles</li>
                                        <li><i className="bi bi-check-circle-fill"></i> View school-wide analytics</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Configure classes and subjects</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Oversee fee collection</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Publish global announcements</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Access all operational modules</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Manager */}
                            <div className="tab-pane fade" id="r-manager" role="tabpanel">
                                <div className="role-pane">
                                    <div className="role-pane-icon">
                                        <i className="bi bi-briefcase"></i>
                                    </div>
                                    <h3>Manager — Operations and Finance</h3>
                                    <p className="role-desc">
                                        Focused on the day-to-day operational and financial supervision
                                        of all school activities and reporting.
                                    </p>
                                    <ul className="role-feat-list">
                                        <li><i className="bi bi-check-circle-fill"></i> Track fee collection and dues</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Run financial reports</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Coordinate staff workflows</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Supervise daily operations</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Monitor attendance summaries</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Manage student records</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Teacher */}
                            <div className="tab-pane fade" id="r-teacher" role="tabpanel">
                                <div className="role-pane">
                                    <div className="role-pane-icon">
                                        <i className="bi bi-person-workspace"></i>
                                    </div>
                                    <h3>Teacher — Classroom Workflow</h3>
                                    <p className="role-desc">
                                        Everything teachers need for daily classroom management,
                                        attendance, grading, and communication.
                                    </p>
                                    <ul className="role-feat-list">
                                        <li><i className="bi bi-check-circle-fill"></i> Mark daily attendance</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Enter and manage exam marks</li>
                                        <li><i className="bi bi-check-circle-fill"></i> View personal timetable</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Post class-level notices</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Access student profiles</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Receive school announcements</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Student */}
                            <div className="tab-pane fade" id="r-student" role="tabpanel">
                                <div className="role-pane">
                                    <div className="role-pane-icon">
                                        <i className="bi bi-mortarboard"></i>
                                    </div>
                                    <h3>Student — Academic Self-Service</h3>
                                    <p className="role-desc">
                                        A personal portal where students can track their academic
                                        progress and stay up to date with school activities.
                                    </p>
                                    <ul className="role-feat-list">
                                        <li><i className="bi bi-check-circle-fill"></i> View attendance records</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Access exam results</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Check class timetable</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Read school notices</li>
                                        <li><i className="bi bi-check-circle-fill"></i> See fee payment status</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Receive push notifications</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Parent */}
                            <div className="tab-pane fade" id="r-parent" role="tabpanel">
                                <div className="role-pane">
                                    <div className="role-pane-icon">
                                        <i className="bi bi-house-heart"></i>
                                    </div>
                                    <h3>Parent — Child Monitoring Portal</h3>
                                    <p className="role-desc">
                                        Real-time visibility into your child's attendance, grades, fee
                                        dues, and important school communications.
                                    </p>
                                    <ul className="role-feat-list">
                                        <li><i className="bi bi-check-circle-fill"></i> Track child's attendance</li>
                                        <li><i className="bi bi-check-circle-fill"></i> View grades and results</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Check fee dues and history</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Receive absence alerts</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Read school notices</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Monitor academic calendar</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Staff */}
                            <div className="tab-pane fade" id="r-staff" role="tabpanel">
                                <div className="role-pane">
                                    <div className="role-pane-icon">
                                        <i className="bi bi-person-badge"></i>
                                    </div>
                                    <h3>Staff — Support Access</h3>
                                    <p className="role-desc">
                                        Non-teaching staff get lightweight access for attendance,
                                        calendars, and internal school notices.
                                    </p>
                                    <ul className="role-feat-list">
                                        <li><i className="bi bi-check-circle-fill"></i> View own attendance records</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Check holiday calendar</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Manage profile settings</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Read internal notice boards</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Receive push notifications</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Access school directory</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ===== MODULES ===== */}
                <section id="modules" style={{ background: "#fff" }}>
                    <div className="container">
                        <div className="text-center mb-5">
                            <span className="sec-label">Module Highlights</span>
                            <h2 className="sec-heading">Built to Scale With Your School</h2>
                            <p className="sec-sub mx-auto">
                                Robust operational modules to run academics, communication, and
                                accounts efficiently across your entire institution.
                            </p>
                        </div>
                        <div className="row g-4">
                            {[
                                {
                                    icon: "bi bi-cash-coin",
                                    title: "Fee Management",
                                    items: [
                                        "Custom fee categories and discounts",
                                        "Per-student payment history",
                                        "Overdue tracking and alerts",
                                        "Receipt generation and reports"
                                    ]
                                },
                                {
                                    icon: "bi bi-calendar2-check",
                                    title: "Attendance Tracking",
                                    items: [
                                        "Daily student and staff capture",
                                        "Class-wise analytics",
                                        "Automated absence alerts",
                                        "Monthly attendance reports"
                                    ]
                                },
                                {
                                    icon: "bi bi-journal-bookmark",
                                    title: "Academics and Exams",
                                    items: [
                                        "Multiple exam types supported",
                                        "Subject-wise mark entry",
                                        "Auto-grade calculation",
                                        "Instant result publishing"
                                    ]
                                },
                                {
                                    icon: "bi bi-bell",
                                    title: "Notifications",
                                    items: [
                                        "Role and class-targeted alerts",
                                        "Web push without app install",
                                        "Fee reminders and events",
                                        "Holiday and exam notices"
                                    ]
                                }
                            ].map((mod, idx) => (
                                <div className="col-md-6 col-lg-3" key={idx}>
                                    <div className="mod-card">
                                        <div className="mod-icon">
                                            <i className={mod.icon}></i>
                                        </div>
                                        <h3>{mod.title}</h3>
                                        <ul className="mod-list">
                                            {mod.items.map((item, i) => (
                                                <li key={i}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section style={{ background: "#fff" }}>
                    <div className="container">
                        <div className="row align-items-start g-5">
                            <div className="col-lg-5">
                                <span className="sec-label">Getting Started</span>
                                <h2 className="sec-heading">Go Live in 4 Simple Steps</h2>
                                <p className="sec-sub">
                                    From initial deployment to daily school operations — a clear,
                                    straightforward onboarding path with no technical expertise
                                    required.
                                </p>
                                <Link
                                    to="https://sms-app-dusky.vercel.app/login"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        background: hover ? "#4d2f7f" : "#6441a5",
                                        color: "#fff",
                                        borderRadius: "50px",
                                        padding: "12px 28px",
                                        fontWeight: 600,
                                        textDecoration: "none",
                                        display: "inline-block",
                                        marginTop: "1.5rem",
                                        transition: "all 0.3s ease"
                                    }}
                                    onMouseEnter={() => setHover(true)}
                                    onMouseLeave={() => setHover(false)}
                                >
                                    Try the Live App
                                </Link>
                            </div>
                            <div className="col-lg-6 offset-lg-1">
                                <div className="tl-wrap">
                                    {steps.map((step, idx) => (
                                        <div className="tl-step" key={idx}>
                                            <div className="tl-num">{step.num}</div>
                                            <h3>{step.title}</h3>
                                            <p>{step.desc}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="faq" style={{ background: "#f8f9fa" }}>
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-4">
                                <span className="sec-label">FAQ</span>
                                <h2 className="sec-heading">Common Questions</h2>
                                <p className="sec-sub">
                                    Quick answers for school owners, administrators, and decision
                                    makers considering this platform.
                                </p>
                            </div>
                            <div className="col-lg-8">
                                <div className="accordion faq-acc" id="faqAccordion">
                                    {faqs.map((faq, idx) => (
                                        <div className="accordion-item" key={faq.id}>
                                            <h3 className="accordion-header">
                                                <button
                                                    className={`accordion-button ${idx !== 0 ? "collapsed" : ""
                                                        }`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#${faq.id}`}
                                                    aria-expanded={idx === 0 ? "true" : "false"}
                                                    aria-controls={faq.id}
                                                >
                                                    {faq.question}
                                                </button>
                                            </h3>
                                            <div
                                                id={faq.id}
                                                className={`accordion-collapse collapse ${idx === 0 ? "show" : ""
                                                    }`}
                                                data-bs-parent="#faqAccordion"
                                            >
                                                <div className="accordion-body">{faq.answer}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="sms-cta" style={{ background: "#000000 !important" }}>
                    <div className="container">
                        <div className="cta-inner text-center">
                            <h2>Ready to Digitize Your School Operations?</h2>
                            <p>
                                See how attendance, fees, exams, and parent communications can run
                                from one secure cloud dashboard. Try the live app instantly — no
                                setup required.
                            </p>
                            <div className="d-flex gap-3 justify-content-center flex-wrap">
                                <Link
                                    to="https://sms-app-dusky.vercel.app/login"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-cta-white"
                                >
                                    <i className="bi bi-box-arrow-up-right me-1"></i> Launch Live App
                                </Link>
                                <Link
                                    to="https://wa.me/919474460058?text=Hello%20Anupam%2C%20I%20want%20to%20discuss%20the%20Cloud%20School%20Management%20System."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-cta-outline"
                                >
                                    <i className="bi bi-whatsapp me-1"></i> Chat on WhatsApp
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
            <Footer />
        </>
    );
};

export default Edras;